// Login session functions put here
import Cookies from "universal-cookie";
import { getUrlParameter } from './helper';
export const cookieOption = (exDay) => {
  if (typeof window !== "undefined") {
    let expDate = new Date(exDay);
    if (exDay <= 366)
      expDate = setCookieExp(exDay)
    if (window.location.protocol === "https:") {
      return {
        expires: expDate,
        path: "/",
        domain: window.location.hostname,
        secure: true
      };
    } else {
      return {
        expires: expDate,
        path: "/",
      };
    }
  }
  return {};
};

export const setCookieExp = (exDay) => {
  const d = new Date();
  d.setTime(d.getTime() + exDay * 24 * 60 * 60 * 1000);
  return d;
};

export const loginCookieExp = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_COOKIES_EXP || 1;

export const getLoginSDKEnv = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_SDK_ENV || "qa";

export const getLoginSDKChannelId = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LC_CHANNEL_ID || "";

export const getLineClient = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LINE_CLIENT_ID || "";

export const getTokenRefreshTime = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_REFRESH_TOKEN || 5;

export const getLoginMaxIdle = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_MAX_IDLE || 120;

export const getLoginTokenValidity = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_SDK_TOKEN_VALIDITY || 30;

export const getSOPPriceChangeEnabled = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .SOP_PRICE_CHANGE || false;

//=========================================================================

export const getAccessHeader = (ctxCookieOrStates = "") => {
  const tokens = getTokens(ctxCookieOrStates);
  return {
    Authorization: "Bearer " + tokens.accessToken,
  };
};

export const getAccessHeaderNew = (ctxCookieOrStates = "") => {
  const tokens = getTokens(ctxCookieOrStates);
  return {
    authorization: tokens.accessToken,
  };
};

export const getTokens = (ctxCookieOrStates = "") => {
  let accessToken = "";
  let idToken = "";
  if (
    typeof window !== "undefined" ||
    (typeof ctxCookieOrStates === "string" && ctxCookieOrStates !== "")
  ) {
    const cookies = new Cookies(ctxCookieOrStates);
    accessToken = cookies.get("accessToken");
    idToken = cookies.get("idToken");
  } else if (
    ctxCookieOrStates &&
    ctxCookieOrStates.loginState &&
    ctxCookieOrStates.loginState.login
  ) {
    accessToken = ctxCookieOrStates.loginState.login.accessToken;
    idToken = ctxCookieOrStates.loginState.login.idToken;
  }

  return {
    accessToken: accessToken,
    idToken: idToken,
  };
};

export const getUsers = (ctxCookieOrStates = "") => {
  let user = {};
  if (
    typeof window !== "undefined" ||
    (typeof ctxCookieOrStates === "string" && ctxCookieOrStates !== "")
  ) {
    const cookies = new Cookies(ctxCookieOrStates);
    user.ada = cookies.get("ada") || "";
    user.distributorType = cookies.get("role") || "Guest";
    user.role = user.distributorType;
    user.mainName = cookies.get("mainName") || "";
    user.usersInfo = cookies.get("user") || [];
    user.loginType = cookies.get("loginType") || "";
    user.loginMemberType = cookies.get("loginMemberType") || "";
  } else if (
    ctxCookieOrStates &&
    ctxCookieOrStates.loginState &&
    ctxCookieOrStates.loginState.login
  ) {
    user.ada = ctxCookieOrStates.loginState.login.ada;
    user.distributorType = ctxCookieOrStates.loginState.login.role;
    user.role = user.distributorType;
    user.mainName = ctxCookieOrStates.loginState.login.mainName;
    user.usersInfo = ctxCookieOrStates.loginState.login.user;
    user.loginType = ctxCookieOrStates.loginState.login.loginType || "";
    user.loginMemberType =
      ctxCookieOrStates.loginState.login.loginMemberType || "";
  }
  return user;
};

export const getADA = (ctxCookieOrStates = "") => {
  let ada = "";
  if (
    typeof window !== "undefined" ||
    (typeof ctxCookieOrStates === "string" && ctxCookieOrStates !== "")
  ) {
    const cookies = new Cookies(ctxCookieOrStates);
    ada = cookies.get("ada") || "";
  } else if (
    ctxCookieOrStates &&
    ctxCookieOrStates.loginState &&
    ctxCookieOrStates.loginState.login
  ) {
    ada = ctxCookieOrStates.loginState.login.ada;
  }
  return ada;
};

export const getRole = (ctxCookieOrStates = "") => {
  let role = "Guest";
  if (
    typeof window !== "undefined" ||
    (typeof ctxCookieOrStates === "string" && ctxCookieOrStates !== "")
  ) {
    const cookies = new Cookies(ctxCookieOrStates);
    role = cookies.get("role") || "Guest";
  } else if (
    ctxCookieOrStates &&
    ctxCookieOrStates.loginState &&
    ctxCookieOrStates.loginState.login
  ) {
    role = ctxCookieOrStates.loginState.login.role;
  }
  return role;
};

export const getPersonalId = (ctxCookieOrState = "") => {
  let user = getUsers(ctxCookieOrState);
  return user && user.usersInfo && user.usersInfo.length > 0
    ? user.usersInfo[0].amwayId || ""
    : "";
};

export const setOnbehalf = (onbehalf) => {
  // CSR only
  /* mandatory structure: {
        ada: int,
        name: string,
        role: string
    }
    */
  if (typeof window !== "undefined") {
    //add listener to localStorage
    var orignalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, newValue) {
      var setItemEvent = new Event("setItemEvent");
      setItemEvent.newValue = newValue;
      window.dispatchEvent(setItemEvent);
      orignalSetItem.apply(this, arguments);
    };

    localStorage.setItem("onbehalf", JSON.stringify(onbehalf));
    //const cookies = new Cookies()
    //cookies.set("onbehalf", JSON.stringify(onbehalf), cookieOption(loginCookieExp()))
  }
};

export const getOnbehalf = () => {
  // CSR Only
  //const cookies = new Cookies(ctxCookie)
  //let onbehalf = cookies.get("onbehalf")
  let onbehalf = '';

  if (typeof window !== "undefined") {
    onbehalf = JSON.parse(
      localStorage.getItem("onbehalf") ||
      '{ "ada": "", "role": "", "name": "", "loginType": "", "loginMemberType": "" }'
    );
  }

  // if no data, set current login user as onbehalf
  if (onbehalf && !onbehalf.ada) {
    let user = getUsers();
    onbehalf = {
      ada: user.ada,
      role: user.role,
      name: user.mainName,
      loginType: user.loginType || "",
      loginMemberType: user.loginMemberType || "",
    };
  }
  return onbehalf;
};

export const setRecipientAddress = (address) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("switch_address", JSON.stringify(address));
  }
};

export const getRecipientAddress = () => {
  let address = '';

  if (typeof window !== "undefined") {
    address = JSON.parse(
      localStorage.getItem("switch_address") ||
      '{ "address": "", "city": "", "combinedAddress": "", "district": "", "districtCode": "", "postCode": "", "mobileNumber": "" }'
    );
  }

  return address;
};

export const getAll = (
  ctxCookieOrState = "",
  ctx = { res: null, req: null },
  redirectLoginIfNotFound = false
) => {
  // for CSR, leave the ctxCookieOrState to empty
  // for SSR, either ctxCookie or state object
  // if in SSR, ctx is provided, it will use it to redirect
  if (!ctx) {
    ctx = { res: null, req: null };
  }
  const tokens = getTokens(ctxCookieOrState);
  if (tokens.accessToken) {
    const user = getUsers(ctxCookieOrState);
    const userInfo = (user &&
      user.usersInfo &&
      user.usersInfo.length > 0 &&
      user.usersInfo[0]) || { amwayId: "", name: "" };
    return {
      accessHeader: {
        Authorization: "Bearer " + tokens.accessToken,
      },
      accessToken: tokens.accessToken,
      idToken: tokens.idToken,
      user: user,
      ada: user.ada,
      role: user.role,
      mainName: user.mainName,
      distributorType: user.role,
      personalId: userInfo.amwayId || "",
      name: userInfo.name || "",
      loginType: user.loginType || "",
      loginMemberType: user.loginMemberType || "",
    };
  } else {
    if (redirectLoginIfNotFound) {
      // temp disable
      if (typeof window !== "undefined") {
        // redirect to landing (to verify login first) if possible
        // if not login, landing will redirect to login
        const parameter = getUrlParameter(window.location?.href);
        let params = `${window.location.pathname}${parameter}`
        window.location.href = `/landing?h=${btoa(params)}`;
        // window.location.href = "/landing?h=" + window.location.pathname + window.location.search;
      }

      // redirect using ctx, for SSR
      if (ctx.res && ctx.req) {
        let path = ctx.req.url || "";
        ctx.res.writeHead(303, { Location: "/landing?h=" + path });
        ctx.res.end();
      }
    }

    // if all not provided, return empty object
    return {
      accessHeader: {},
      accessToken: "",
      idToken: "",
      user: [],
      ada: "",
      role: "",
      distributorType: "",
      personalId: "",
      name: "",
      loginType: "",
      loginMemberType: "",
    };
  }
};

export const getCommonParameters = () => {
  if (typeof window === "undefined")
    return {
      loginAda: "",
      loginMemberType: "",
      loginType: "",
      bizCode: "",
      channelCode: "",
    };

  const cookie = new Cookies();

  return {
    loginAda: cookie.get("ada") || "",
    loginMemberType: cookie.get("role") || "Guest",
    loginType: cookie.get("loginType") || "",
  };
};

export const isOnlineReturnDisabled = () => {
  const menuData = JSON.parse(localStorage.getItem("menuList"));
  if (menuData && menuData.length > 0) {
    for (var i = 0; i < menuData.length; i++) {
      if (menuData[i].target_url?.link?.href === "/onlinereturn/returns") {
        return false;
      }
    };
  }

  return true;
}
